import type { QuickAction, ShellConfig } from "@repo/dashboard-core";

import { languageLabels, locales } from "./locales";
import { headerActions, navItems, userMenuItems } from "./navigation";

export const shellConfig = {
  navItems,
  headerActions,
  userMenuItems,
  locales,
  languageLabels,
} satisfies Omit<ShellConfig, "brand">;

// Quick actions for the FloatingActionButton drawer. The Upload File action
// is prepended in DashboardShell — it needs the upload hook and router.
export const quickActions: QuickAction[] = [
  {
    icon: "messages",
    titleKey: "quick-actions.messages",
    descriptionKey: "quick-actions.messages-desc",
    href: "/messages",
  },
  {
    icon: "phone",
    titleKey: "quick-actions.contact",
    descriptionKey: "quick-actions.contact-desc",
    href: "/contact",
  },
];
